import { createContext, useContext } from 'react';
export const PipelineCtx = createContext(null);
export const usePipeline = () => useContext(PipelineCtx);
